export default "__VITE_ASSET__B2lC93Xs__"